import { createAction, props } from '@ngrx/store';
import { Quota } from '../../features/quotas/models/quota.interface';

export const loadQuotaSummary = createAction('[Quota] Load Summary');

export const loadQuotaSummarySuccess = createAction(
  '[Quota] Load Summary Success',
  props<{ quotas: Quota[] }>()
);

export const loadQuotaSummaryFailure = createAction(
  '[Quota] Load Summary Failure',
  props<{ error: string }>()
);
